module.exports = __webpack_public_path__ + "static/media/arrow_left_btn.4b30124c.svg";